Controller.$inject = ['$element', '$transclude'];

function Controller($element, $transclude) {
    const self = this;
    self.isOpen = false;
    self.hasAccordionRightContent = false;

    self.togglePanel = () => {
        self.isOpen = !self.isOpen;
        const nextElement = $element[0].nextElementSibling;
        if (nextElement) {
            angular.element(nextElement).toggleClass('open', self.isOpen);
        }
    };

    self.$onInit = () => {
        if (self.parentCtrl.expanded) {
            self.isOpen = true;
            const nextElement = $element[0].nextElementSibling;
            if (nextElement) {
                angular.element(nextElement).addClass('open');
            }
        }
    };

    self.$postLink = () => {
        self.hasAccordionRightContent = $transclude.isSlotFilled('rightContent');
    };
}

export function HuiAccordionHeader() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        require: {
            parentCtrl: '^huiAccordion'
        },
        transclude: {
            'actions': '?accordionActions',
            'title': '?accordionTitle',
            'rightContent': '?accordionRightContent',
        },
        template: ($element, $attrs) => {
            return `
             <div class="hui-accordion-header"
                  ng-click="$huiCtrl.togglePanel()"
                  ng-class="{ 'panel-open': $huiCtrl.isOpen }">
                  <span class="hui-accordion-icon">
                       <ng-transclude ng-transclude-slot="actions"></ng-transclude>
                       <i class="chevron-icon fa"
                          ng-class="{
                               'fa-chevron-right': !$huiCtrl.isOpen,
                               'fa-chevron-down': $huiCtrl.isOpen}">    
                       </i>
                  </span>
                  <div ng-class="{'with-right-content': $huiCtrl.hasAccordionRightContent}">
                      <span class="accordion-title" ng-transclude ng-transclude-slot="title"></span>
                      <span ng-transclude ng-transclude-slot="rightContent"></span>
                  </div>
             </div>
            `;
        }
    }
}